import React from 'react';
import { Link } from 'react-router-dom';
import PlatformLayout from '../PlatformLayout';
import PlatformStateMap from '../PlatformStateMap';
import { usePlatformStateMap } from '../usePlatformStateMap';
import { Arrow } from '../icons';

export default function Footprint() {
  const { stateMap, optedInCount, total } = usePlatformStateMap();
  return (
    <PlatformLayout>
      {/* Hero band on navy so the map reads as the payoff below it. */}
      <section className="sgk-hero">
        <div className="sgk-wrap sgk-hero__grid">
          <div>
            <span className="sgk-eyebrow">Your footprint</span>
            <h1>The credit follows the <em>state line.</em></h1>
            <p className="sgk-hero__lede">
              Section 25F only works where a state has opted into the program. Your
              footprint is the map of where your donors actually earn the $1,700 —
              so it belongs on your homepage, not buried in a policy PDF.
            </p>
            <div className="sgk-hero__ctas">
              <Link to="/signup" className="sgk-btn sgk-btn--gold" data-testid="footprint-start-button">
                Claim your states <Arrow />
              </Link>
            </div>
          </div>
          <div className="sgk-creditcard">
            <div className="sgk-creditcard__rows">
              <div className="sgk-creditcard__row"><span className="k">51</span><span>jurisdictions — 50 states + DC — configured per organization.</span></div>
              <div className="sgk-creditcard__row"><span className="k">{optedInCount ?? '—'}</span><span>have opted into Section 25F — the same for every organization.</span></div>
              <div className="sgk-creditcard__row"><span className="k">{optedInCount === undefined || total === undefined ? '—' : total - optedInCount}</span><span>not yet — they appear on every map the day they opt in.</span></div>
            </div>
          </div>
        </div>
      </section>

      <section className="sgk-section">
        <div className="sgk-wrap">
          <div className="sgk-head sgk-head--center sgk-reveal" style={{ marginBottom: 40 }}>
            <span className="sgk-eyebrow">Where it&apos;s opted in</span>
            <h2>Every state, straight from the roster.</h2>
            <p>Toggle a state on and it appears on your public map instantly. Toggle it
              off and the roster still knows the row exists — nobody can walk your
              configuration to guess where you&apos;re merely considering.</p>
          </div>
          <div className="sgk-reveal">{stateMap && <PlatformStateMap data={stateMap} />}</div>
        </div>
      </section>

      <section className="sgk-section sgk-credit" style={{ paddingTop: 0 }}>
        <div className="sgk-wrap sgk-credit__grid" style={{ paddingTop: 'clamp(60px,8vw,112px)' }}>
          <div className="sgk-reveal">
            <span className="sgk-eyebrow">How the map works</span>
            <h2>Public where it should be, <em>private where it must be.</em></h2>
            <p>Your footprint is a marketing asset, so the map that draws it is public —
              no login, served on your own subdomain. It publishes only what a donor
              needs: the state, whether you&apos;re registered, and whether it&apos;s opted in.</p>
            <p>Everything else — eligibility rules, internal notes, states you&apos;re only
              weighing — stays behind the authenticated console. The map is proof, not a
              leak.</p>
          </div>
          <div className="sgk-creditcard sgk-reveal">
            <div className="sgk-creditcard__num" style={{ fontSize: '46px' }}>Live map</div>
            <div className="sgk-creditcard__lbl">rendered from your own configuration</div>
            <hr />
            <div className="sgk-creditcard__rows">
              <div className="sgk-creditcard__row"><span className="k">Public</span><span>State, registration status, and opt-in — on your subdomain, no login.</span></div>
              <div className="sgk-creditcard__row"><span className="k">Private</span><span>Eligibility, school types, and pending states stay authenticated.</span></div>
              <div className="sgk-creditcard__row"><span className="k">No map</span><span>Server rules — no tile server, no API key, no external request.</span></div>
            </div>
          </div>
        </div>
      </section>

      <section className="sgk-cta">
        <div className="sgk-wrap sgk-cta__grid">
          <div>
            <h2>Put your footprint on the map.</h2>
            <p>Configure all 51 jurisdictions and publish the states that count.</p>
          </div>
          <Link to="/signup" className="sgk-btn sgk-btn--navy" data-testid="footprint-cta-start-button">
            Start an SGO <Arrow />
          </Link>
        </div>
      </section>
    </PlatformLayout>
  );
}
